import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import EditIcon from '@material-ui/icons/Edit';
import {
    Card,
    CardHeader,
    CardContent,
    CardActions,
    Button,
    Divider,
    Table,
    TableBody,
    TableRow,
    TableCell,
    colors
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { delete_agency } from '../../../api/API';

import EditAgency from '../../EditAgency/EditAgency';

const useStyles = makeStyles(theme => ({
    root: {},

    content: {
        padding: 0
    },

    actions: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        '& > * + *': {
            marginLeft: 0
        }
    },

    buttonIcon: {
        marginRight: theme.spacing(1)
    },

    editButton: {
        color: theme.palette.white,
        backgroundColor: colors.blue[600],
        '&:hover': {
            backgroundColor: colors.blue[900]
        }
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },


}));

export default class DetailData extends React.Component {

    constructor(props) {
        super(props);
        console.log('DetailData');
        console.log(props);
        this.state = {
            agencys: props.agencys,
            agency_id: props.agency_id,
            show_edit: false
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            agencys: props.agencys
        });
    }

    handleEditOpen() {
        //setOpenEdit(true);
    };

    handleEditClose() {
        this.setState({
            ...this.state,
            show_edit: false
        });
        this.props.refresh();
    };

    async handleDelete() {
        if (window.confirm("Are you sure ?")) {
            let data = await delete_agency(this.state.agency_id);
            if (data) {
                this.props.history.push("/agency");
            } else {
                alert("Something went wrong");
            }

        }
    }

    render() {
        return (

            <Card
                {...this.props.rest}

            >
                <CardHeader title="Agency Detail"
                    action={(
                        <React.Fragment>
                            {window.localStorage.getItem("role") == 'superadmin' ?
                                <React.Fragment>
                                    <Button variant="contained"
                                        onClick={() => {
                                            this.setState({
                                                ...this.state,
                                                show_edit: true
                                            });
                                        }}
                                    >
                                        <EditIcon className={this.props.classes.leftIcon} />
                                    Edit</Button>
                                    <Button variant="contained"
                                        style={{
                                            backgroundColor: "red",
                                            marginLeft: 10
                                        }}
                                        onClick={(() => {
                                            this.handleDelete();
                                        }).bind(this)}
                                    >
                                        <DeleteIcon className={this.props.classes.leftIcon} />
                                Delete</Button>
                                </React.Fragment>
                                : ''
                            }
                        </React.Fragment>
                    )}

                />
                <Divider />
                <CardContent >
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>
                                    {this.state.agencys.name}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Email</TableCell>
                                <TableCell>{this.state.agencys.email}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Contact Number</TableCell>
                                <TableCell>{this.state.agencys.contact}</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </CardContent>
                <CardActions className={this.props.classes.actions}>
                    {/* <Button className={this.props.classes.editButton} onClick={this.handleEditOpen}>
                        Edit
                    </Button> */}

                </CardActions>
                {this.state.show_edit && (
                    <EditAgency

                        agency={this.state.agencys}
                        onClose={this.handleEditClose.bind(this)}
                        open={this.state.show_edit}
                    />
                )}

            </Card>
        );
    }
}